<script setup lang="ts">
import BaseButton from "@/components/ui/BaseButton/BaseButton.vue";
</script>

<template>
  <BaseButton class="skip-button">
    <slot />
  </BaseButton>
</template>

<style scoped lang="scss">
@use "@/styles/z-index";
@use "@/styles/variables/colors";
@use "@/styles/mixins/a11y";

.skip-button {
  @include a11y.skip-button-highlight;

  position: fixed;
  top: 20px;
  left: 20px;
  opacity: 0;
  z-index: z-index.$a11y-hidden;

  &:focus,
  :focus-within {
    z-index: z-index.$a11y-visible;
    opacity: 1;
  }
}
</style>
